import React from 'react';

import AppearTransition from './AppearTransition';

import error from '../imgs/error.svg';

// preload svg
(function() {
  const img = new Image();
  img.src = error;
}());

export default function Failed({title, message}) {
  return <div className="App-Card animated">
    <AppearTransition animation="zoomIn">
      <div className="animated App-Card-decoration">
        <img className="App-Card-avatar" src={error} alt="Error" />
      </div>
    </AppearTransition>

    <h1 className="App-Card-title">{title}</h1>
    <div className="App-Card-message">{message}</div>
    <div className="App-Card-action">
      <a className="App-Card-button" href="mailto:support@noa.one">Contact Support</a>
      <p>
      <a href="#" onClick={(e) => location.reload()}>
        Try again (reload)
      </a>
      </p>
    </div>
  </div>
}



// WEBPACK FOOTER //
// ./src/lib/Failed.js